import React from 'react';
import { Container, Typography, Box, Paper, Divider, Chip } from '@mui/material';
import PublicHeader from '../components/PublicHeader';
import Footer from '../components/Footer';

const PURPLE = '#00F1A7';
const GREEN = '#22C55E';
const LIME = '#00F1A7';

export default function RegrasTeste() {
  return (
    <>
      <PublicHeader />
      <Box sx={{ bgcolor: '#f8f9fa', minHeight: '70vh', py: { xs: 4, md: 6 } }}>
        <Container maxWidth="md">
          <Paper sx={{ p: { xs: 3, md: 5 }, borderRadius: 3 }}>
            <Typography variant="h4" sx={{ fontWeight: 800, mb: 1, color: PURPLE }}>
              Regras do Período de Teste e Pagamento
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
              Última atualização: 20 de Junho de 2026
            </Typography>

            <Divider sx={{ my: 3 }} />

            <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
              1. Período de Teste Gratuito
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.8 }}>
              Toda igreja que se cadastra na ConectaChurch tem direito a <strong>7 (sete) dias corridos de teste gratuito</strong> no
              plano Semente. O período de teste começa automaticamente na data de cadastro da igreja e é contado em dias
              corridos (incluindo fins de semana e feriados).
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.8, mt: 1 }}>
              Nenhum dado de cartão de crédito é solicitado para iniciar o período de teste.
            </Typography>

            <Box sx={{
              bgcolor: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: 2, p: 2.5, mt: 2, mb: 1
            }}>
              <Typography variant="subtitle1" sx={{ fontWeight: 700, color: '#166534', mb: 1 }}>
                O que está incluído no trial
              </Typography>
              <Box component="ul" sx={{ mt: 0.5, pl: 2.5, color: '#166534', lineHeight: 2 }}>
                <li>Cadastro de membros ilimitado (até 50 membros)</li>
                <li>Módulo de Secretaria completo</li>
                <li>Módulo de Consolidação</li>
                <li>Módulo Start (boas-vindas para novos convertidos)</li>
                <li>Até 2 usuários administrativos</li>
                <li>Suporte via WhatsApp e e-mail</li>
                <li>Acesso web e mobile (PWA)</li>
              </Box>
            </Box>

            <Divider sx={{ my: 3 }} />

            <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
              2. Planos e Preços
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.8 }}>
              A ConectaChurch oferece 4 planos para atender igrejas de todos os tamanhos:
            </Typography>

            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 2 }}>

              <Paper variant="outlined" sx={{ p: 2.5, borderRadius: 2 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                  <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>Plano Semente</Typography>
                  <Chip label="Grátis" size="small" sx={{ bgcolor: GREEN, color: '#fff', fontWeight: 700 }} />
                </Box>
                <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.8 }}>
                  Ideal para igrejas iniciantes. Inclui Secretaria e Consolidação com até 50 membros e 2 usuários.
                  Sem custo, sem cartão de crédito.
                </Typography>
              </Paper>

              <Paper variant="outlined" sx={{ p: 2.5, borderRadius: 2, borderColor: LIME, borderWidth: 1.5 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                  <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>Plano Essencial</Typography>
                  <Chip label="R$97/mês" size="small" sx={{ bgcolor: PURPLE, color: '#fff', fontWeight: 700 }} />
                </Box>
                <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.8 }}>
                  Inclui tudo do plano Semente + Módulo Start. Até 200 membros, 5 usuários administrativos.
                </Typography>
              </Paper>

              <Paper variant="outlined" sx={{ p: 2.5, borderRadius: 2 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                  <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>Plano Crescimento</Typography>
                  <Chip label="R$197/mês" size="small" sx={{ bgcolor: '#F59E0B', color: '#fff', fontWeight: 700 }} />
                </Box>
                <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.8 }}>
                  Inclui tudo do Essencial + Cursos e Treinamentos, Discipulado, Grupos de Crescimento. Até 500 membros,
                  10 usuários.
                </Typography>
              </Paper>

              <Paper variant="outlined" sx={{ p: 2.5, borderRadius: 2 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                  <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>Plano Pleno</Typography>
                  <Chip label="R$297/mês" size="small" sx={{ bgcolor: '#DC2626', color: '#fff', fontWeight: 700 }} />
                </Box>
                <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.8 }}>
                  Todos os módulos da plataforma, membros ilimitados, usuários ilimitados. Inclui Financeiro, Jornada do
                  Membro, Voluntariado, Gestão de Obreiros e Notificações avançadas.
                </Typography>
              </Paper>
            </Box>

            <Divider sx={{ my: 3 }} />

            <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
              3. Como Contratar um Plano Pago
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.8 }}>
              Para migrar do teste gratuito para um plano pago, siga estes passos:
            </Typography>
            <Box component="ol" sx={{ mt: 0.5, pl: 2.5, color: 'text.secondary', lineHeight: 2 }}>
              <li>Acesse a Plataforma com suas credenciais de administrador da igreja</li>
              <li>Acesse as configurações da igreja (Dashboard)</li>
              <li>Selecione o plano desejado (Essencial, Crescimento ou Pleno)</li>
              <li>Você será redirecionado ao checkout seguro do Stripe</li>
              <li>Preencha os dados de pagamento (cartão de crédito ou débito)</li>
              <li>Após a confirmação do pagamento, seu plano será ativado imediatamente</li>
            </Box>
            <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.8, mt: 1 }}>
              Todos os pagamentos são processados via <strong>Stripe</strong>, uma das maiores plataformas de pagamento do
              mundo, com certificação PCI-DSS nível 1. A ConectaChurch não armazena dados de cartão de crédito.
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.8, mt: 1 }}>
              Formas de pagamento aceitas: cartão de crédito, cartão de débito e PIX (quando disponível na sua região).
            </Typography>

            <Divider sx={{ my: 3 }} />

            <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
              4. Renovação Automática
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.8 }}>
              A assinatura é renovada automaticamente a cada 30 (trinta) dias, sempre no mesmo dia do mês da contratação
              inicial. O valor é debitado automaticamente no cartão cadastrado, sem necessidade de confirmação adicional.
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.8, mt: 1 }}>
              Caso o pagamento da renovação seja recusado (cartão sem limite, expirado etc.), o Stripe tentará
              automaticamente por até 3 vezes em dias alternados. Se todas as tentativas falharem, o acesso às
              funcionalidades do plano pago será suspenso até a regularização do pagamento.
            </Typography>

            <Divider sx={{ my: 3 }} />

            <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
              5. Cancelamento da Assinatura
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.8 }}>
              O cancelamento da assinatura pode ser feito a qualquer momento diretamente pela Plataforma, na seção de
              configurações da igreja. Ao cancelar:
            </Typography>
            <Box component="ul" sx={{ mt: 0.5, pl: 2.5, color: 'text.secondary', lineHeight: 2 }}>
              <li>O acesso às funcionalidades do plano pago permanece ativo até o fim do ciclo já pago</li>
              <li>Nenhuma cobrança adicional será feita após o cancelamento</li>
              <li>Ao final do ciclo pago, sua conta será revertida para o plano Semente gratuito</li>
              <li>Seus dados permanecem armazenados por 90 dias caso queira reativar a assinatura</li>
            </Box>
            <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.8, mt: 1 }}>
              O cancelamento também pode ser feito cancelando a assinatura diretamente no painel do Stripe, mas recomendamos
              utilizar a Plataforma para garantir a sincronização correta do status.
            </Typography>

            <Divider sx={{ my: 3 }} />

            <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
              6. Política de Reembolso
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.8 }}>
              Nossa política de reembolso é clara e justa:
            </Typography>
            <Box component="ul" sx={{ mt: 0.5, pl: 2.5, color: 'text.secondary', lineHeight: 2 }}>
              <li><strong>Reembolso integral</strong> se solicitado em até 7 (sete) dias corridos após a data do pagamento</li>
              <li>Após 7 dias do pagamento, <strong>não há direito a reembolso</strong></li>
              <li>O reembolso será processado em até 15 (quinze) dias úteis</li>
              <li>O valor é devolvido pelo mesmo meio de pagamento utilizado (cartão de crédito)</li>
              <li>Para solicitar reembolso, entre em contato pelo e-mail contato@smyrnacore.com.br</li>
            </Box>
            <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.8, mt: 1 }}>
              Não há reembolso proporcional ou parcial — o reembolso é integral ou não concedido. Em caso de insatisfação,
              recomendamos solicitar o cancelamento para evitar cobranças futuras e utilizar o restante do período já pago.
            </Typography>

            <Divider sx={{ my: 3 }} />

            <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
              7. Bonificação para Igrejas Parceiras
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.8 }}>
              A ConectaChurch possui um programa de bonificação para igrejas parceiras ou indicadas por parceiros estratégicos.
              Igrejas bonificadas têm acesso estendido gratuito ao plano contratado, sem cobrança recorrente.
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.8, mt: 1 }}>
              A bonificação é concedida exclusivamente pela equipe SmyrnaCore e pode ser revogada a qualquer momento, a
              critério da SmyrnaCore. Igrejas bonificadas:
            </Typography>
            <Box component="ul" sx={{ mt: 0.5, pl: 2.5, color: 'text.secondary', lineHeight: 2 }}>
              <li>Não pagam mensalidade durante o período de bonificação</li>
              <li>Têm acesso completo às funcionalidades do plano bonificado</li>
              <li>Não geram direito adquirido à gratuidade permanente</li>
              <li>Serão notificadas com 30 dias de antecedência em caso de revogação da bonificação</li>
              <li>Podem migrar voluntariamente para um plano pago, abrindo mão da bonificação</li>
            </Box>

            <Divider sx={{ my: 3 }} />

            <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
              8. Upgrade e Downgrade de Planos
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.8 }}>
              <strong>Upgrade (migrar para plano superior):</strong> pode ser feito a qualquer momento. A diferença
              proporcional entre os planos é cobrada no momento do upgrade, e o novo ciclo de 30 dias inicia imediatamente.
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.8, mt: 1 }}>
              <strong>Downgrade (migrar para plano inferior):</strong> entra em vigor no início do próximo ciclo de
              cobrança. Até lá, você mantém o acesso ao plano atual. Se sua igreja exceder os limites do plano inferior
              (ex.: número de membros), será necessário adequar-se antes do downgrade.
            </Typography>

            <Box sx={{
              bgcolor: '#faf5ff', border: '1px solid #e9d5ff', borderRadius: 2, p: 2.5, mt: 4
            }}>
              <Typography variant="subtitle1" sx={{ fontWeight: 700, color: '#6B21A8', mb: 1 }}>
                Dúvidas?
              </Typography>
              <Typography variant="body2" sx={{ color: '#6B21A8', lineHeight: 1.8 }}>
                Nossa equipe está disponível para esclarecer qualquer dúvida sobre planos, pagamentos ou período de teste.
                Entre em contato pelo e-mail contato@smyrnacore.com.br ou WhatsApp (81) 99600-1383.
              </Typography>
            </Box>

            <Typography variant="body2" color="text.secondary" sx={{ mt: 4, textAlign: 'center' }}>
              SmyrnaCore Tecnologia LTDA — CNPJ 66.330.452/0001-40
            </Typography>
          </Paper>
        </Container>
      </Box>
      <Footer />
    </>
  );
}
